export default {
  'data': [{
    'id': '212601397',
    'name': '场地经营',
    'description': null,
    'hierarchy': 1,
    'parentId': '0',
    'frontUrl': 'http',
    'backUrl': null,
    'target': null,
    'sort': 5,
    'status': 1,
    'createAt': 1538101643819,
    'createBy': 'lizhilong',
    'updateAt': 1539090566929,
    'updateBy': 'xiongfudan',
    'icon': 'https://img1.jianyewy.com/2327bdc511c7cb69e7ce6ab33904b383.png',
    'platformCode': 'B',
    'tenementId': '2018091314160173934',
    'subMenuList': [{
      'id': '230427210',
      'name': '社区资源管理系统',
      'description': null,
      'hierarchy': 2,
      'parentId': '212601397',
      'frontUrl': '/thome/4',
      'backUrl': null,
      'target': null,
      'sort': 1,
      'status': 1,
      'createAt': 1538101679444,
      'createBy': 'lizhilong',
      'updateAt': 1538101679444,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': null,
      'isLeaf': null
    }, {
      'id': '555988446',
      'name': '场地管理系统',
      'description': null,
      'hierarchy': 2,
      'parentId': '212601397',
      'frontUrl': '/thome/4',
      'backUrl': null,
      'target': null,
      'sort': 2,
      'status': 1,
      'createAt': 1538193491038,
      'createBy': 'lizhilong',
      'updateAt': 1538193491038,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': null,
      'isLeaf': null
    }],
    'isLeaf': null
  }, {
    'id': '797272107',
    'name': '社商经营',
    'description': null,
    'hierarchy': 1,
    'parentId': '0',
    'frontUrl': 'http',
    'backUrl': null,
    'target': null,
    'sort': 6,
    'status': 1,
    'createAt': 1538100548401,
    'createBy': 'lizhilong',
    'updateAt': 1538277465819,
    'updateBy': 'lizhilong',
    'icon': 'https://img1.jianyewy.com/70a6588f8d94c906cda032267f7bd3fa.png',
    'platformCode': 'B',
    'tenementId': '2018091314160173934',
    'subMenuList': [{
      'id': '282286933',
      'name': '社商自运营系统',
      'description': null,
      'hierarchy': 2,
      'parentId': '797272107',
      'frontUrl': '/thome/7',
      'backUrl': null,
      'target': null,
      'sort': 1,
      'status': 1,
      'createAt': 1538100610542,
      'createBy': 'lizhilong',
      'updateAt': 1538100610542,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': null,
      'isLeaf': null
    }, {
      'id': '379921097',
      'name': '聚合业态系统',
      'description': null,
      'hierarchy': 2,
      'parentId': '797272107',
      'frontUrl': '/thome/4',
      'backUrl': null,
      'target': null,
      'sort': 2,
      'status': 1,
      'createAt': 1538100649479,
      'createBy': 'lizhilong',
      'updateAt': 1538100649479,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': [{
        'id': '374861279',
        'name': '商业概览',
        'description': null,
        'hierarchy': 3,
        'parentId': '379921097',
        'frontUrl': '/business/overview',
        'backUrl': null,
        'target': null,
        'sort': 1,
        'status': 1,
        'createAt': 1538101040930,
        'createBy': 'lizhilong',
        'updateAt': 1539087442114,
        'updateBy': 'xiongfudan',
        'icon': null,
        'platformCode': 'B',
        'tenementId': '2018091314160173934',
        'subMenuList': null,
        'isLeaf': null
      }, {
        'id': '574424733',
        'name': '业态概览',
        'description': null,
        'hierarchy': 3,
        'parentId': '379921097',
        'frontUrl': '/thome/8',
        'backUrl': null,
        'target': null,
        'sort': 2,
        'status': 1,
        'createAt': 1538101073990,
        'createBy': 'lizhilong',
        'updateAt': 1539087473341,
        'updateBy': 'xiongfudan',
        'icon': null,
        'platformCode': 'B',
        'tenementId': '2018091314160173934',
        'subMenuList': null,
        'isLeaf': null
      }, {
        'id': '721463475',
        'name': '业态市场',
        'description': null,
        'hierarchy': 3,
        'parentId': '379921097',
        'frontUrl': '/type/overview',
        'backUrl': null,
        'target': null,
        'sort': 3,
        'status': 1,
        'createAt': 1538101106603,
        'createBy': 'lizhilong',
        'updateAt': 1539087502499,
        'updateBy': 'xiongfudan',
        'icon': null,
        'platformCode': 'B',
        'tenementId': '2018091314160173934',
        'subMenuList': null,
        'isLeaf': null
      }],
      'isLeaf': null
    }, {
      'id': '502558843',
      'name': '业务经营系统',
      'description': null,
      'hierarchy': 2,
      'parentId': '797272107',
      'frontUrl': '/thome/4',
      'backUrl': null,
      'target': null,
      'sort': 3,
      'status': 1,
      'createAt': 1538101165566,
      'createBy': 'lizhilong',
      'updateAt': 1538101165566,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': null,
      'isLeaf': null
    }],
    'isLeaf': null
  }, {
    'id': '730723766',
    'name': '数字资产',
    'description': null,
    'hierarchy': 1,
    'parentId': '0',
    'frontUrl': 'http',
    'backUrl': null,
    'target': null,
    'sort': 7,
    'status': 1,
    'createAt': 1538099932294,
    'createBy': 'lizhilong',
    'updateAt': 1538277476123,
    'updateBy': 'lizhilong',
    'icon': 'https://img1.jianyewy.com/b212cedc3a6a33308e45392f27f3d7a8.png',
    'platformCode': 'B',
    'tenementId': '2018091314160173934',
    'subMenuList': [{
      'id': '616641310',
      'name': '用户数据概览',
      'description': null,
      'hierarchy': 2,
      'parentId': '730723766',
      'frontUrl': '/thome/4',
      'backUrl': null,
      'target': null,
      'sort': 1,
      'status': 1,
      'createAt': 1538099995087,
      'createBy': 'lizhilong',
      'updateAt': 1538099995087,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': null,
      'isLeaf': null
    }, {
      'id': '299405188',
      'name': '社区健康指数',
      'description': null,
      'hierarchy': 2,
      'parentId': '730723766',
      'frontUrl': '/thome/6',
      'backUrl': null,
      'target': null,
      'sort': 2,
      'status': 1,
      'createAt': 1538100044772,
      'createBy': 'lizhilong',
      'updateAt': 1538100044772,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': null,
      'isLeaf': null
    }, {
      'id': '607220401',
      'name': '业态指引',
      'description': null,
      'hierarchy': 2,
      'parentId': '730723766',
      'frontUrl': '/thome/4',
      'backUrl': null,
      'target': null,
      'sort': 3,
      'status': 1,
      'createAt': 1538100100217,
      'createBy': 'lizhilong',
      'updateAt': 1538100100217,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': null,
      'isLeaf': null
    }, {
      'id': '607220422',
      'name': '用户权益',
      'description': null,
      'hierarchy': 2,
      'parentId': '730723766',
      'frontUrl': '/thome/4',
      'backUrl': null,
      'target': null,
      'sort': 4,
      'status': 1,
      'createAt': 1538100100217,
      'createBy': 'lizhilong',
      'updateAt': 1538100100217,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': null,
      'isLeaf': null
    }, {
      'id': '623922484',
      'name': '用户列表',
      'description': null,
      'hierarchy': 2,
      'parentId': '730723766',
      'frontUrl': '/thome/4',
      'backUrl': null,
      'target': null,
      'sort': 5,
      'status': 1,
      'createAt': 1538100178137,
      'createBy': 'lizhilong',
      'updateAt': 1538100178137,
      'updateBy': 'lizhilong',
      'icon': null,
      'platformCode': 'B',
      'tenementId': '2018091314160173934',
      'subMenuList': null,
      'isLeaf': null
    }],
    'isLeaf': null
  }]
};